import React from 'react';
import Navbar from '../Navbar';
import Footer from '../Footer';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRobot, faBrain, faChartLine, faCode, faCubes, faCogs, faServer   } from '@fortawesome/free-solid-svg-icons';

import './products.css';

const Products = () => {
    return (
        <div>
            <div className='min-h-screen flex flex-col'>
                <Navbar/>
                <div class="container">
  <h2 class="section-title">Products</h2>
    <div class="services-inner">
        
        <div class="services-box">
        <span class="icon">
            <FontAwesomeIcon  icon={faRobot} className='product-icons'/>
        </span>
        <h3 class="services-title">Rasas</h3>
        <h2>Data Annotation</h2>
        </div>
        
        <div class="services-box">
        <span class="icon">
        <FontAwesomeIcon icon={faCode} className='product-icons'/>
        </span>
        <h3 class="services-title">Rasai</h3>
        <h2>Dataset Managment</h2>
        </div>
        
        <div class="services-box">
        <span class="icon">
            <FontAwesomeIcon icon={faBrain} className='product-icons'/>
        </span>
        <h3 class="services-title">Rasint</h3>
        <h2>Ai Integration</h2>
        </div>
        
        <div class="services-box">
        <span class="icon">
            <FontAwesomeIcon icon={faChartLine} className='product-icons'/>
        </span>
        <h3 class="services-title">Rasval</h3>
        <h2>Ai Bias & Validation</h2>
        </div>
        
        <div class="services-box">
        <span class="icon">
            <FontAwesomeIcon icon={faCubes} className='product-icons'/>
        </span>
        <h3 class="services-title">Rascals</h3>
        <h2>Custom Ai Business Solutions</h2>
        </div>
    </div>
  
  <div className='py-2'>
    <h2 class="section-title">RAS Library</h2>
    <span className='text-white' >Rapid AI is a company that provides various AI services to businesses across different industries. Their product line includes RASAS, RASAI, RASINT, RASVAL, and RASCALS.</span>
  </div>
    
  <div class="lContainer flex flex-wrap">
  <div class="grid grid-cols-2 gap-4">
    <div class="services-box w-full md:w-[12vw]">
      <span class="icon">
        <FontAwesomeIcon icon={faRobot} className='product-icons'/>
      </span>
      <h3 class="services-title">Rasas</h3>
      <h2>Data Annotation</h2>
    </div>
    <div className='desc flex-1 text-white'>
      <p>
        RASAS (Rapid Annotation Services at Scale) is a service that uses expert annotators and AI tools to deliver high-quality annotation services at scale. This helps clients quickly and accurately label and categorize their image datasets.
      </p>
    </div>

    <div class="services-box w-full md:w-[12vw]">
      <span class="icon">
        <FontAwesomeIcon icon={faCode} className='product-icons'/>
      </span>
      <h3 class="services-title">Rasai</h3>
      <h2>Dataset Management</h2>
    </div>
    <div className='desc flex-1 text-white'>
      <p>
        RASAI (Rapid AI Image Management) is a service that provides tools and features to help clients organize and manage their large datasets, including image tagging, metadata management, and version control.
      </p>
    </div>

    <div class="services-box w-full md:w-[12vw]">
      <span class="icon">
        <FontAwesomeIcon icon={faBrain} className='product-icons'/>
      </span>
      <h3 class="services-title">Rasint</h3>
      <h2>AI Integration</h2>
    </div>
    <div className='desc flex-1 text-white'>
      <p>
        RASINT (Rapid AI Integration) is a service that helps businesses seamlessly incorporate AI capabilities into their existing systems and processes.
      </p>
    </div>
  </div>

  <div class="grid grid-cols-2 gap-4">
    <div class="services-box w-full md:w-[12vw]">
      <span class="icon">
        <FontAwesomeIcon icon={faChartLine} className='product-icons'/>
      </span>
      <h3 class="services-title">Rasval</h3>
      <h2>AI Validation</h2>
    </div>
    <div className='desc flex-1 text-white'>
      <p>
        RASVAL (Rapid AI Validation) is a service that ensures the AI models and algorithms developed by clients are accurate and reliable.
      </p>
    </div>

    <div class="services-box w-full md:w-[12vw]">
      <span class="icon">
        <FontAwesomeIcon icon={faCubes} className='product-icons'/>
      </span>
      <h3 class="services-title">Rascals</h3>
      <h2>Custom AI Solutions</h2>
    </div>
    <div className='desc flex-1 text-white'>
      <p>
        RASCALS (Rapid Custom AI Solutions) is a service that offers customized AI solutions to meet the unique needs of clients, including specialized AI models and tailored integration solutions.
      </p>
    </div>
  </div>
  </div>



  
                </div>
                <Footer/>
            </div>
        </div>
    );
}

export default Products;
